import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="border-y border-lava/30 bg-petrol py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-65" data-mp="12slodzpkpx35">
      <div className="mx-auto max-w-4xl px-4" data-id="element-66" data-mp="xt92bh6j0u1m">
        <div className="text-center" data-id="element-67" data-mp="xsfqi1spnecm">
          <h2 id="closing-title" className="text-balance font-display text-4xl font-bold leading-[1.05] text-snow sm:text-5xl" data-id="element-68" data-mp="1cqrocbrtkt5d">
            Next Monday you can keep improvising…
          </h2>
          <p className="mt-4 text-balance font-display text-3xl font-bold text-lava sm:text-4xl" data-id="element-69" data-mp="1lia2kh57gyvt">
            Or you can enter your classroom fully prepared starting today.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-70" data-mp="1viki48epqie5">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-xl border-l-4 border-lava bg-carbon/60 px-4 py-3 text-sm font-semibold text-snow" data-id="element-71" data-mp="1qjr14607w998" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-lava" aria-hidden="true" data-id="element-72" data-mp="2ga0uk3qnskaa" />
              {line}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-73" data-mp="2q99lsou53ksy">
          <p className="leading-relaxed text-muted" data-id="element-74" data-mp="2v19q0th8szvc">
            This teacher ready won't make you a better educator. You're already an excellent educator.
          </p>
          <p className="mt-3 text-lg font-bold text-snow" data-id="element-75" data-mp="3027690iozju7">
            What this teacher ready does is give you the time and tools so that excellence shows in every single class.
          </p>
        </div>
      </div>
    </section>;
}